import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#ToastState">ToastState</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`The current state of the toast store.`}</p>
      </dd>
      <dt><a href="#ToastContextProvider">ToastContextProvider</a></dt>
      <dd>
        <p>{`A `}<a parentName="p" {...{
            "href": "https://reactjs.org/docs/context.html"
          }}>{`context`}</a>{` provider that
provides the toast state object and a dispatch function to toast
functionality consumers.`}</p>
      </dd>
      <dt><a href="#useToastContext">useToastContext</a> ⇒ <inlineCode>Array.&lt;Object&gt;</inlineCode></dt>
      <dd>
        <p>{`A hook that provides access to the toast state and dispatch.
Any component using this hook `}<em parentName="p">{`must`}</em>{` be a child of a `}<a parentName="p" {...{
            "href": "#ToastContextProvider"
          }}>{`ToastContextProvider`}</a>{`.`}</p>
      </dd>
    </dl>
    <p>{`The current state of the toast store.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`toasts`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Map`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Map object associating an id to toast data`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`A `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/context.html"
      }}>{`context`}</a>{` provider that
provides the toast state object and a dispatch function to toast
functionality consumers.`}</p>
    <p>{`A hook that provides access to the toast state and dispatch.
Any component using this hook `}<em parentName="p">{`must`}</em>{` be a child of a `}<a parentName="p" {...{
        "href": "#ToastContextProvider"
      }}>{`ToastContextProvider`}</a>{`.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`Array.<Object>`}</inlineCode>{`
— An array containing the state and dispatch function: [`}<a parentName="p" {...{
        "href": "#ToastState"
      }}>{`ToastState`}</a>{`, function]`}</p>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const [toastState, dispatch] = useToastState();
`}</code></pre>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/Toasts/useToastContext.js"
      }}>{`pwa-studio/packages/peregrine/lib/Toasts/useToastContext.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      